import { Box } from '@dtx-company/design-system/src/components/Box/Box'
import { Typography, theme } from '@dtx-company/design-system/src'
import Image from 'next/image'

export const CTA = ({
  img,
  line1,
  line2,
  line2Href,
  trackLinkClick
}: {
  img: { alt?: string; url?: string }
  line1: string
  line2: string
  line2Href?: string
  trackLinkClick: () => void
}): JSX.Element | null => {
  if (line1.length === 0 && line2.length === 0) return null
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        gap: '24px'
      }}
    >
      <Box
        sx={{
          position: 'relative',
          width: { xs: '64px', md: '80px' },
          height: { xs: '64px', md: '80px' }
        }}
      >
        <Image
          src={img.url || ''}
          alt={img.alt || 'broken image'}
          loading={'lazy'}
          width={80}
          height={80}
        />
      </Box>
      <Box sx={{ display: 'flex', flexDirection: 'column' }}>
        <Typography variant="bodyMedium" component="p" color={theme.builder.space30}>
          {line1}
        </Typography>
        <Box
          sx={{
            marginTop: 2,
            cursor: 'pointer'
          }}
        >
          <Typography variant="bodyLarge" component="p" color={theme.builder.space30}>
            <a
              href={line2Href}
              onClick={trackLinkClick}
              style={{ textDecoration: 'underline', color: 'inherit' }}
            >
              {line2}
            </a>
          </Typography>
        </Box>
      </Box>
    </Box>
  )
}
